const mutationsSubscribeNames = [
  'setInputValue',
]

function getInitState() {
  return {
    muted: false,
    inputs: {
      workplace_company_name: {
        value: null
      },
      workplace_information: {
        value: null
      },
      country_id: {
        value: null
      },
      city_id: {
        value: null
      },
      workplace_address: {
        value: null
      },
      workplace_comment: {
        value: null
      }
    }
  }
}

export default {
  namespaced: true,
  state: {
    ...getInitState(),
    mutationsSubscribeNames
  },
  mutations: {
    setMuted(state, value) {
      state.muted = value
    },
    resetState(state) {
      Object.assign(state, getInitState())
    },
    setInputValue(state, {key, value}) {
      if (!state.inputs.hasOwnProperty(key)) return
      state.inputs[key].value = value
    }
  },
  actions: {
    setVacancyValues({state, commit}, vacancy) {
      for (let key in state.inputs) {
        commit('setInputValue', {key, value: vacancy[key]})
      }

      commit('setMuted', false)
    }
  },
  getters: {
    isFilledInfo(state) {
      if (!state.inputs.workplace_information.value) return false
      let valueObj = JSON.parse(state.inputs.workplace_information.value)

      for (let key in valueObj) {
        if (valueObj[key]) {
          return true
        }
      }

      return false
    },
    isFilledAddress(state) {
      return state.inputs.country_id.value && state.inputs.country_id.value.id &&
        state.inputs.city_id.value && state.inputs.city_id.value.id &&
        state.inputs.workplace_address.value
    }
  }
}
